// This file was auto-generated by Fern from our API Definition.
import * as FernIr from "../../../../../index.mjs";
export const NamedType = {
    alias: (value) => {
        return Object.assign(Object.assign({}, value), { type: "alias", _visit: function (visitor) {
                return FernIr.dynamic.NamedType._visit(this, visitor);
            } });
    },
    enum: (value) => {
        return Object.assign(Object.assign({}, value), { type: "enum", _visit: function (visitor) {
                return FernIr.dynamic.NamedType._visit(this, visitor);
            } });
    },
    object: (value) => {
        return Object.assign(Object.assign({}, value), { type: "object", _visit: function (visitor) {
                return FernIr.dynamic.NamedType._visit(this, visitor);
            } });
    },
    discriminatedUnion: (value) => {
        return Object.assign(Object.assign({}, value), { type: "discriminatedUnion", _visit: function (visitor) {
                return FernIr.dynamic.NamedType._visit(this, visitor);
            } });
    },
    undiscriminatedUnion: (value) => {
        return Object.assign(Object.assign({}, value), { type: "undiscriminatedUnion", _visit: function (visitor) {
                return FernIr.dynamic.NamedType._visit(this, visitor);
            } });
    },
    _visit: (value, visitor) => {
        switch (value.type) {
            case "alias":
                return visitor.alias(value);
            case "enum":
                return visitor.enum(value);
            case "object":
                return visitor.object(value);
            case "discriminatedUnion":
                return visitor.discriminatedUnion(value);
            case "undiscriminatedUnion":
                return visitor.undiscriminatedUnion(value);
            default:
                return visitor._other(value);
        }
    },
};
